import React from 'react';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import FinalDenialEmailDialog from 'areas/admin/certification/shared/FinalDenialEmailDialog';

export const renderAdminStepToolbar = (reviewTypeCode, queueTypeCode, form, props, ref) => {       
	return (
		<AdminStepToolbar
			ref={(c) => { ref = c }}
			certificationKey={props.selectedId}
			reviewTypeCode={reviewTypeCode}
			queueTypeCode={queueTypeCode}
			comments={form.comments}
			showCancel={false}
			showSave={false}
			setupProps={props.setupProps}
			handleTabSelect={props.handleTabSelect}
		/>
	);
}

export const renderFinalDenialEmailDialog = (state, onClose, onDeny) => {       
	return (
		<FinalDenialEmailDialog
			visible={state.emailDialog}
			to={state.emailDialogTo}
			subject={state.emailDialogSubject}
			message={state.emailDialogMessage}
			onClose={onClose}
			onSend={onDeny}
			entityId={state.form.entityId}
			certificationId={state.form.certificationId}
			rowVersion={state.form.rowVersion}
		/>
	);
}


// WEBPACK FOOTER //
// ./src/areas/shared/helpers/ReviewHelpers.js